module.exports = __webpack_public_path__ + "img/monitoring-ship-red.b49391c2.svg";